import { AllowedRedirectUrl } from '../enum/UrlAppMap';

/**
 * Configuration for a redirect rule
 */
export interface RedirectRule {
  /** List of hostnames that this rule applies to */
  hostnames: string[];
  /** The path to redirect from */
  fromPath: string;
  /** The path to redirect to (must be a valid app route) */
  toPath: AllowedRedirectUrl;
  /** Optional condition function for additional logic */
  condition?: () => boolean;
}

/**
 * Centralized redirect rules configuration
 */
export const REDIRECT_RULES: RedirectRule[] = [
  {
    hostnames: ['productfinder.insidebrady.com'],
    fromPath: '/',
    toPath: '/product-finder',
  },
  {
    hostnames: ['esa.insidebrady.com'],
    fromPath: '/',
    toPath: '/chat',
  },
];

/**
 * Gets redirect rules that apply to the current hostname
 * @param hostname The current hostname to check against
 * @returns Array of applicable redirect rules
 */
export const getApplicableRedirectRules = (hostname: string): RedirectRule[] => {
  return REDIRECT_RULES.filter((rule) =>
    rule.hostnames.some((ruleHostname) => {
      // Check if hostname ends with the rule hostname (supports subdomains)
      return hostname === ruleHostname || hostname.endsWith('.' + ruleHostname);
    })
  );
};

/**
 * Finds a matching redirect rule for the given hostname and pathname
 * @param hostname The current hostname
 * @param pathname The current pathname
 * @returns The matching redirect rule or undefined if no match
 */
export const findMatchingRedirectRule = (hostname: string, pathname: string): RedirectRule | undefined => {
  const applicableRules = getApplicableRedirectRules(hostname);

  return applicableRules.find((rule) => pathname === rule.fromPath && (!rule.condition || rule.condition()));
};
